/* eslint-disable max-len */
import { Accordion, AccordionProps, styled } from "@mui/material";

import React from "react";

interface HealthRecordsAccordionProps extends AccordionProps {
  expanded: boolean;
}

export const HealthRecordsAccordion = styled(({ expanded, ...props }: HealthRecordsAccordionProps) => (
  <Accordion expanded={expanded} {...props} />
))(({ theme }) => ({
  "&.MuiAccordion-root": {
    "boxShadow": "none",
    "transition": ".3s all",
    "borderRadius": "0.5rem",
    "border": `1px solid ${theme.palette.taupe.dark}`,
    "backgroundColor": theme.palette.white.main,
    "&:before": {
      display: "none",
    },
    "&.Mui-expanded": {
      margin: 0,
    },

    "& .MuiAccordionSummary-root": {
      "padding": "0 1rem",
      "height": "3.75rem",
      "minHeight": "3.75rem",
      "borderRadius": "7px 7px 0 0",
      "transition": "background-color .3s",
      "&.Mui-expanded": {
        minHeight: "3.75rem",
        backgroundColor: "#E6E5F1",
      },
      "& .MuiAccordionSummary-content": {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        margin: 0,
      },
    },

    "& .MuiAccordionSummary-expandIconWrapper": {
      transition: "transform .3s",
    },
    "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
      transform: "rotate(90deg)",
    },

    "& .MuiAccordionDetails-root": {
      padding: "0.875rem 1.75rem 1.75rem 1.75rem",
    },
  },
}));

export const AccordionRowHeader = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "1rem",
  flexShrink: 0,
  flexGrow: 1,
}));
